export default __webpack_public_path__ + "static/media/designer.8c062b77.png";